const sortQuestionOptions = (question) => {
  if (!question || !Array.isArray(question.options)) {
    return question;
  }
  // Return a new question object with a new, sorted options array
  const sortedOptions = [...question.options].sort(
    (a, b) => a.order_index - b.order_index
  );
  return { ...question, options: sortedOptions };
};

export default sortQuestionOptions;
